import React from "react";

const About = () => {
  return (
    <div className="w-full text-gray-800">

      {/* HERO */}
      <section className="relative bg-gradient-to-r from-teal-900 to-teal-700 text-white">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <span className="uppercase text-sm tracking-wider opacity-80">
            About us
          </span>
          <h1 className="text-4xl md:text-5xl font-semibold mt-4 max-w-3xl">
            TechSPR outcomes let you thrive
          </h1>
        </div>
      </section>

      {/* INTRO */}
      <section className="bg-white py-20 px-6">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-semibold mb-6">
              We position you to succeed in the sprint for digital dominance
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              We’re a leader in digital customer experience engineering.
              We’re based in Silicon Valley with design and build centers
              around the globe. We empower companies in the travel, retail,
              insurance, and tech verticals accelerate their experience-led
              transformation in the delivery of digital platforms using
              technologies such as cloud, microservices, automation, IoT,
              and artificial intelligence.
            </p>

            <div className="grid grid-cols-3 gap-6 mt-10 text-center">
              <div>
                <p className="text-3xl font-bold text-cyan-500">95%</p>
                <p className="text-sm mt-1">Client retention rate</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-cyan-500">24</p>
                <p className="text-sm mt-1">Fortune 500 clients</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-cyan-500">6,000+</p>
                <p className="text-sm mt-1">Employees</p>
              </div>
            </div>
          </div>

          <img
            src="/images/company/about/hero.jpg"
            alt="Team collaboration"
            className="rounded-lg shadow-lg"
          />
        </div>
      </section>

      {/* CORE VALUES */}
      <section className="bg-gray-50 py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-semibold mb-12">
            TechSPR Core Values
          </h2>

          <div className="grid md:grid-cols-2 gap-10">
            {[
              {
                title: "Grow together",
                desc: "We empower and activate people and businesses to reach their full potential.",
              },
              {
                title: "Create client value",
                desc: "We exceed client expectations. Always.",
              },
              {
                title: "Innovate",
                desc: "We don’t wait for change. We create it.",
              },
              {
                title: "Deliver excellence",
                desc: "We’re accountable to ourselves and to every client and colleague. No excuses. Ever.",
              },
            ].map((item, i) => (
              <div key={i} className="flex gap-4">
                <div className="w-10 h-10 bg-cyan-500 rounded-full flex items-center justify-center text-white font-bold">
                  ✓
                </div>
                <div>
                  <h4 className="font-semibold uppercase text-sm mb-1">
                    {item.title}
                  </h4>
                  <p className="text-gray-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ESG / PURPOSE */}
      <section className="bg-black text-white py-24 px-6">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-semibold mb-6">
              Our place, and role, in meaningful change
            </h2>
            <p className="text-gray-300 leading-relaxed mb-6">
              We excel at human-centric solutions because we put people first.
              Our clients. Their customers. Our employees. Their families.
              The technology we specialize in has vast potential to serve
              humanity. That is why we are passionate about it and its
              applications for change.
            </p>
            <button className="border border-white px-6 py-3 rounded hover:bg-white hover:text-black transition">
              Download now →
            </button>
          </div>
          <img
            src="/images/company/about/globle.jpg"
            alt="Global impact"
            className="rounded-lg"
          />
        </div>
      </section>

      {/* RECOGNITION */}
      <section className="bg-gray-50 py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-semibold mb-6">Recognition</h2>
          <p className="text-gray-600 mb-10">
            We’re recognized globally for growth and acquisitions.
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                img: "/images/company/about/data1.jpg",
                title: "We’re a Leader in Data Engineering",
                desc: "ISG Provider Lens™ Analytics Services – Midsize",
              },
              {
                img: "/images/company/about/data2.jpg",
                title: "Top Cloud Transformation Partner",
                desc: "Global Tech Awards – Cloud Innovation Category",
              },
              {
                img: "/images/company/about/data3.jpg",
                title: "Fastest Growing Digital Company",
                desc: "Business Excellence Awards – 2025",
              },
            ].map((item, i) => (
              <div key={i} className="bg-white p-6 rounded shadow-sm">
                {/* same layout — only dynamic data */}
                <img src={item.img} alt={item.title} className="mb-4" />

                <h4 className="font-semibold mb-2">{item.title}</h4>

                <p className="text-sm text-gray-600">{item.desc}</p>

                <button className="text-cyan-600 mt-4 text-sm font-medium">
                  See the report →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* LEADERSHIP */}
      <section className="bg-gradient-to-r from-indigo-900 to-purple-900 text-white py-24 px-6">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-semibold mb-6">
              Meet the visionaries who lead TechSPR
            </h2>
            <p className="text-gray-300 mb-6">
              Our leaders are committed to building a future in which
              businesses nurture their employees and communities where they do
              business, grow constantly, and make the world a better place.
            </p>
            <button className="border px-6 py-3 rounded hover:bg-white hover:text-black transition">
              Meet our team →
            </button>
          </div>
        </div>
      </section>

      {/* CAREERS */}
      {/* <section className="relative py-24 px-6">
        <img
          src="/images/careers.jpg"
          alt="Careers"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative max-w-7xl mx-auto text-white">
          <h2 className="text-3xl font-semibold mb-4">
            Interested in working for TechSPR?
          </h2>
          <button className="border px-6 py-3 rounded hover:bg-white hover:text-black transition">
            Take the next step →
          </button>
        </div>
      </section> */}

      {/* CONTACT */}
      {/* <section className="bg-black text-white py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-semibold mb-10">Let’s Connect</h2>
          <form className="grid md:grid-cols-3 gap-6">
            <input className="p-3 rounded text-black" placeholder="First Name*" />
            <input className="p-3 rounded text-black" placeholder="Last Name*" />
            <input className="p-3 rounded text-black" placeholder="Company Name*" />
            <input className="md:col-span-2 p-3 rounded text-black" placeholder="Email Address*" />
            <select className="p-3 rounded text-black">
              <option>What would you like to talk about?</option>
              <option>Services</option>
              <option>Careers</option>
              <option>Partnerships</option>
            </select>
            <button className="md:col-span-3 bg-cyan-600 hover:bg-cyan-700 px-6 py-3 rounded font-medium">
              Connect
            </button>
          </form>
        </div>
      </section> */}

    </div>
  );
};

export default About;
